import React from "react";
import bg5 from "../../images/main-slider/bg3.png"; // Replace with your mountain image
import logo from "../../images/Zentara Logo Inverse.png";

const Hero2 = () => {
  return (
    <section
      id="home"
      style={{
        backgroundImage: `url(${bg5})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
        position: "relative",
      }}
    >
      {/* Overlay for contrast */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.3)",
          zIndex: 1,
        }}
      ></div>

      {/* Content */}
      <div style={{ zIndex: 2 }}>
        <img 
          src={logo} 
          alt="Logo" 
          style={{
            maxWidth: "200px",
            height: "auto",
            marginBottom: "0rem",
            display: "block",
            margin: "0 auto 0rem auto",
          }}
        />
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "900",
            margin: "0.5rem 0",
            lineHeight: "1.1",
            color: "#ffffffff",
            backgroundColor: "rgba(255, 255, 255, 0)",
            padding: "0 1rem",
            display: "inline-block",
          }}
        >
          SEEKING THE CLARITY <br />  AND GROWTH YOU DESERVE?
        </h1>
        <p
          style={{
            fontSize: "1.4rem",
            fontWeight: "400",
            color: "#fff",
            marginTop: "1rem",
            letterSpacing: "1px",
          }}
        >
          Join our intimate 3-day residency
        </p>
        <p
          style={{
            fontSize: "1.4rem",
            fontWeight: "400",
            color: "#fff",
            marginTop: "1rem",
            letterSpacing: "1px",
          }}
        >
          20 Professionals × 3 Days × 1 Secret Place
        </p>

        <a
          href="https://forms.fillout.com/t/9Tmchxsi4jus"
          target="_blank"
          rel="noopener noreferrer"
          style={{
          display: "inline-block",
          marginTop: "2rem",
          backgroundColor: "#ffeb00",
          color: "#000",
          padding: "0.9rem 2.5rem",
          borderRadius: "40px",
          fontWeight: "700",
          textDecoration: "none",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          }}
          onMouseEnter={(e) => {
          e.target.style.backgroundColor = "#fff7a3ff";
          e.target.style.transform = "translateY(-3px)";
          e.target.style.boxShadow = "0 6px 12px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
          e.target.style.backgroundColor = "#ffeb00";
          e.target.style.transform = "translateY(0)";
          e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
          }}
          >
          CLAIM YOUR INVITE
          </a>

        <p
          style={{
            marginTop: "2rem",
            fontSize: "1.1rem",
            color: "#fff",
            opacity: "0.9",
          }}
        >
          Invite-Only Experience
        </p>
      </div>
    </section>
  );
};

export default Hero2;
